import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import API from "../base/API";
import Form from "../form/Form";
import { Tabs, Tab, Panel } from 'react-bootstrap';
import Auth from "../auth/Auth";
import { getUser, hasPermission } from "../auth/Auth";
import TestFiles from "./TestFiles";
import { browserHistory } from "react-router";
import InlineForm from "./parts/InlineForm";
import TestResult from "./parts/TestResult";
import PDFButton from "./parts/PDFButton";
import PDFButtonPlain from "./parts/PDFButtonPlain";
import Opposition from "../opposition/Opposition";
import moment from "moment";
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/omega/theme.css';
import { translate } from '../base/Translation';

import TestLog from "./parts/TestLog";

/*eslint no-restricted-globals: 0 */

export default class Test extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_test: "/test/fetch/:test",
            get_weave_group_results: "/test/fetch/weave_group/results/:weave_group",
            change_test_status: "/test/status/:test/:status",
            get_oppositions: "/opposition/fetch/by/test/:testID"
        });

        let defaultTab = window.location.hash.replace("#", "");
        defaultTab = defaultTab === "" ? "test_info" : defaultTab

        this.state = {
            test: null,
            branch_results: [],
            showOppositions: false,
            activeKey: defaultTab,
            oppositions: [],
        };
    }

    componentDidMount() {
        this._ismounted = true;
        this.fetchData();
        window.addEventListener("hashchange", this.hashChange.bind(this));
    }

    componentWillUnmount() {
        this._ismounted = false;
        window.removeEventListener("hashchange", this.hashChange.bind(this));
    }

    hashChange(e) {
        if (this._ismounted) {
            this.setState({ activeKey: window.location.hash.replace("#", "") });
        }
    }

    fetchData() {
        this.api.request({
            cache: false,
            route: "get_test",
            params: { test: this.props.params.testID },
            success: function (test) {
                this.api.request({
                    route: "get_oppositions",
                    params: { "testID": test.id },
                    success: (oppositions) => {
                        this.setState({ oppositions, test });
                    }
                });
            }.bind(this),
            failure: (response, promise) => {
                alert(response.message);
                browserHistory.push("/tests");
            }
        });
    }

    renderSupervisor() {
        if (getUser().role < 5) {
            return false;
        }

        return (
            <tr>
                <td>{translate("Supervízor")}</td>
                <td>{typeof this.state.test.supervisor_data !== "undefined" ? this.state.test.supervisor_data.name : "---"}</td>
            </tr>
        )
    }

    renderInternalUser() {
        if (getUser().role < 5) {
            return false;
        }

        return (
            <tr>
                <td>{translate("Inšpektor")}</td>
                <td>{this.state.test.internal_user !== 0 ? this.state.test.internal_user_data.name : "--"}</td>
            </tr>
        )
    }

    renderForm() {

        if (!this.state.test.form) {
            return false;
        }

        return (
            <Tab eventKey="test_forms" title={translate("Dotazník")}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group" style={{ textAlign: "right" }}>
                            {[4].indexOf(getUser().role) !== -1 ? "" : <PDFButton type="form" test={this.state.test} />}
                            <PDFButtonPlain type="form" test={this.state.test} />
                        </div>
                    </div>
                </div>
                <Form
                    id={this.state.test.form.id}
                    test={this.props.params.testID}
                    testObj={this.state.test}
                    type="test"
                    fetchData={this.fetchData.bind(this)}
                    parent={this} />
            </Tab>
        )
    }

    renderGuides() {
        if (getUser().role < 4) {
            return "";
        }

        return (
            <Tab eventKey="test_guide" title={translate("Pokyny")}>
                <Panel header={translate("Pokyny vyplňovania dotazníka")}>
                    <div dangerouslySetInnerHTML={{ __html: this.state.test.questionaire_instructions }} />
                </Panel>
                <Panel header={translate("Spracovanie príloh")}>
                    <div dangerouslySetInnerHTML={{ __html: this.state.test.processing_attachments }} />
                </Panel>
                <Panel header={translate("Scenár návštevy")}>
                    <div dangerouslySetInnerHTML={{ __html: this.state.test.visit_scenario }} />
                </Panel>
            </Tab>
        )
    }

    renderLog() {
        if (getUser().role < 5) {
            return "";
        }
        return (
            <Tab eventKey="test_log" title={translate("Denník")}>
                <TestLog test={this.state.test} />
            </Tab>
        )
    }

    renderFiles() {
        return (
            <Tab eventKey="test_attachments" title={translate("Prílohy")}>
                <TestFiles test={this.state.test} />
            </Tab>
        )
    }

    renderTestInfo() {


        let statuses = [];
        const testStatus = this.state.test.status_val;

        switch (testStatus) {
            case "in_progress": // Rozpracovaný
                statuses.push({ value: "in_progress", text: translate("Rozpracovaný") })
                statuses.push({ value: "verified", text: translate("Kontrolovaný") });
                break;
            case "verified": // Kontrolovaný
                statuses.push({ value: "in_progress", text: translate("Rozpracovaný") })
                statuses.push({ value: "verified", text: translate("Kontrolovaný") });
                statuses.push({ value: "closed", text: translate("Ukončený") });
                break;
            case "closed": // Ukončený
                if (getUser().role === 7) {
                    statuses.push({ value: "verified", text: translate("Kontrolovaný") });
                }
                statuses.push({ value: "closed", text: translate("Ukončený") });
                if (getUser().role === 3) {
                    statuses.push({ value: "done", text: translate("Vykonaný") });
                }
                break;
            case "done": // Vykonaný
                if (getUser().role === 7) {
                    statuses.push({ value: "verified", text: translate("Kontrolovaný") });
                }
                statuses.push({ value: "done", text: translate("Vykonaný") });
                break;
            case "archived": // Archivovaný
                statuses.push({ value: "verified", text: translate("Kontrolovaný") });
                statuses.push({ value: "archived", text: translate("Archivovaný") });
                break;
            default:
                break;
        }


        if (getUser().role === 7) {
            statuses = [
                { value: "in_progress", text: translate("Rozpracovaný") },
                { value: "verified", text: translate("Kontrolovaný") },
                { value: "closed", text: translate("Ukončený") },
                { value: "done", text: translate("Vykonaný") },
                { value: "archived", text: translate("Archivovaný") }
            ];
        }

        let canChangeTestDate = hasPermission("TestStatusChange", this.state.test);

        if (canChangeTestDate && this.state.test.date && getUser().role === 4) {
            let now = moment();
            let oneDayBeforeTest = moment(this.state.test.date, "DD.MM.YYYY    HH:mm").subtract(24, 'hours');
            let nowIsOlderThenOneDayBefore = now.isAfter(oneDayBeforeTest);
            if (nowIsOlderThenOneDayBefore) {
                canChangeTestDate = false;
            }
        }


        return (
            <Tab eventKey="test_info" title={translate("Identifikácia MS")}>
                <table className="table table-striped table-bordered table-hover">
                    <tbody>
                        <tr>
                            <td>{translate("Prevádzka")}</td>
                            <td>{this.state.test.branch_data.name}, {this.state.test.branch_data.address}</td>
                        </tr>
                        <tr>
                            <td>{translate("Klient (objednávateľ)")}</td>
                            <td>{this.state.test.weave_data.client.name}</td>
                        </tr>
                        <tr>
                            <td>{translate("Plánovaný dátum a čas návštevy")}</td>
                            <td>
                                <InlineForm readonly={!canChangeTestDate} field="TestDate" type="datetime" value={this.state.test.date} test={this.state.test.id} />
                            </td>
                        </tr>
                        <tr>
                            <td>{translate("Skutočný dátum a čas návštevy")}</td>
                            <td>
                                <InlineForm readonly={!hasPermission("TestStatusChange", this.state.test)} field="VisitTime" value={this.state.test.visit_time} test={this.state.test.id} />
                            </td>
                        </tr>
                        <tr>
                            <td>{translate("Názov testu")}</td>
                            <td>{this.state.test.name}</td>
                        </tr>
                        <tr>
                            <td>{translate("Status testu")}</td>
                            <td>
                                <InlineForm
                                    readonly={!hasPermission("TestStatusChange", this.state.test)}
                                    field="Status"
                                    value={this.state.test.status_val}
                                    test={this.state.test.id}
                                    type="select"
                                    onSuccess={(value, oldValue) => {
                                        if (value !== oldValue) {
                                            if (getUser().role === 4) {
                                                location.href = "/tests";
                                            } else {
                                                location.reload();
                                            }
                                        }
                                    }}
                                    options={statuses}
                                />
                            </td>
                        </tr>
                        {this.renderRepresentative()}
                        {this.renderExternalUser()}
                        {this.renderInternalUser()}
                        {this.renderSupervisor()}
                    </tbody>
                </table>


                {(this.state.test.status_val === "closed" || this.state.test.status_val === "done") && getUser().role > 2 ? <button className="btn btn-primary" style={{ marginTop: "1rem" }} onClick={(evt) => {
                    this.setState({ showOppositions: true, activeKey: "test_oppositions" });
                }}>{translate("Pridať námietku")}</button> : ""}

            </Tab>
        )
    }

    renderRepresentative() {
        return (
            <tr>
                <td>{translate("Predajca")}</td>
                <td>
                    <InlineForm readonly={!hasPermission("TestStatusChange", this.state.test)} field="Representative" value={this.state.test.representative} test={this.state.test.id} />
                </td>
            </tr>
        )
    }

    renderExternalUser() {
        if (getUser().role < 5) {
            return;
        }

        return (
            <tr>
                <td>{translate("Mystery Shopper")}</td>
                <td>
                    {this.state.test.external_user ? this.state.test.external_user_data.name : "---"}
                </td>
            </tr>
        )
    }

    onTabSelect(activeKey) {
        window.location.hash = activeKey;
        this.setState({ activeKey: activeKey });
    }

    renderOppositions() {
        return (
            <Tab eventKey="test_oppositions" title={translate("Námietky")}>
                <Opposition test={this.state.test} />
            </Tab>
        )
    }

    renderResult() {
        return (
            <Tab eventKey="test_results" title={translate("Výsledky")}>
                <TestResult test={this.state.test} />
            </Tab>
        )
    }

    render() {

        if (this.state.test === null) {
            return (
                <Page>
                    <PageHeader>{translate("Prosím počkajte")}</PageHeader>
                    <PageBody>{translate("Obsah sa načítava")}</PageBody>
                </Page>
            )
        }

        const test = this.state.test;
        const branchData = test.branch_data;

        const pageTitlePadding = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        const pageTitle = test.name + pageTitlePadding + branchData.name + ", " + branchData.address;

        let showOppositions = this.state.showOppositions;

        const isClosed = this.state.test.status_val === "closed";
        const isDone = this.state.test.status_val === "done";
        const isArchived = this.state.test.status_val === "archived";

        if (this.state.oppositions.length > 0 && getUser().role === 3 && (isClosed || isDone || isArchived)) {
            showOppositions = true;
        }

        /*
        if (this.state.oppositions.length > 0 && getUser().role === 2 && (isDone || isArchived)) {
            showOppositions = true;
        }
        */

        if (this.state.oppositions.length > 0 && getUser().role >= 5) {
            showOppositions = true;
        }

        return (
            <Page className="container-fluid">
                <PageHeader title={pageTitle} right={() => {
                    return false;
                }} />
                <PageBody>
                    <Tabs activeKey={this.state.activeKey} onSelect={this.onTabSelect.bind(this)} id="controlled-tab-example">
                        {this.renderTestInfo()}
                        {this.renderForm()}
                        {this.renderFiles()}
                        {getUser().role !== 4 ? this.renderResult() : ""}
                        {this.renderGuides()}
                        {this.renderLog()}
                        {showOppositions ? this.renderOppositions() : false}
                    </Tabs>
                </PageBody>
            </Page>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/Test.js